import { useMemo } from 'react';

import {
  loadOrderFieldsSchema,
  orderFieldsSchemaBuilder,
  updateOrderFieldsSchema,
} from '@cd3p/core/modules/orderFieldsSchema';

import { bindActionCreators, useDispatch, useSelector } from 'third-party';

import { appSelectors } from 'selectors';

export const useOrderFieldsSchema = (customProviderId?: string) => {
  const dispatch = useDispatch();
  const defaultProviderId = useSelector(appSelectors.providerId);
  const providerId = customProviderId || defaultProviderId;

  return useMemo(
    () =>
      bindActionCreators(
        {
          loadOrderFieldsSchema: loadOrderFieldsSchema.bind(null, providerId),
          updateOrderFieldsSchema: updateOrderFieldsSchema.bind(
            null,
            providerId,
          ),
        },
        dispatch,
      ),
    [dispatch, providerId],
  );
};

export const orderFieldsSchemaReducer = orderFieldsSchemaBuilder.getReducers();
